const selfSelector = (state) => state.trackerStats;

export default selfSelector;
